exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dynamic-pricing-rule-component[data-v-5cc9f1c8]{flex:1}input[type=checkbox][data-v-5cc9f1c8],input[type=radio][data-v-5cc9f1c8]{margin:4px 0 0;margin-top:1px\\9;line-height:normal;box-shadow:none}input[type=number][data-v-5cc9f1c8]{box-shadow:none;border-radius:5px}.error[data-v-5cc9f1c8]{color:red}.row.align-items-end[data-v-5cc9f1c8]{display:flex;align-items:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5cc9f1c8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicPricingRuleComponent.vue
// module id = 895
// module chunks = 2